import Head from "next/head";
import Footer from "@/shared/components/Footer";
import Templates from "@/widgets/index";
import styles from "./styles.module.css";
import { useState, useEffect } from "react";
import Header from "@/shared/components/Header";
import ContenedorTitulo from "@/shared/components/ContenedorTitulo";

import { useAppContext } from "@pagegrowler_nextjs";
import Chartbeat from "@/shared/components/Chartbeat";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";


const Titulos = (props) => {
  // estado booleano, para determinar si la data que se le envia a NotaDeSeccion, viene del servidor o del cliente
	const [conditionDataRender, setConditionDataRender] = useState(false);

  const LOAD_MORE = 12;

  const pg = useAppContext();
  const Pagegrowler = pg.pagegrowler;

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hideLoadMore, setHideLoadMore] = useState(false);

  const { content, menu = [], pagination = {}, widgets } = { ...props };

  async function showMoreData() {
    setConditionDataRender(true)
		setIsLoading(true);
		let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
		if (res.content && res.content.length > 0) {
			setData(prevState => [...prevState, ...res.content]);
			setOffset(offset + LOAD_MORE);
			setIsLoading(false);
		} else {
			setHideLoadMore(true);
		}
	}

  useEffect(() => {
    setOffset(pagination.limit + pagination.offset);
    setData(content);
  }, []);

  let dataLDJson = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Diario El Litoral",
    "url": "https://www.ellitoral.com",
    "logo": {
      "@type": "ImageObject",
      "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
      "width": 439,
      "height": 60
    },
    "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
  };
  return (
    <>
      <Head>
        <title>Todos los títulos - El Litoral</title>
        <meta name="description" property="description" content="Todos los títulos - El Litoral. Noticias actualizadas las 24 horas." />
        <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />
        <meta httpEquiv="refresh" content="600" />
      </Head>
      <Chartbeat />
      <Header menues={menu} isOpenSidePanel={(open) => setOpen(open)} />
      <div className={`${styles["parent"]}`}>
        <div className={`${styles['main-container']}`}>
          {!props.preview && <Templates.BannerHorizontalChico bannerId={`top`} />}
          <ContenedorTitulo text={`Todos los títulos`} />
          <div className={`${styles["grid-container"]}`}>
            <div className={`${styles["detail-left"]}`}>
              {data && <Templates.NotasDePortada content={conditionDataRender ? data : content} />}

              <div className={`${styles['btn-container']}`}>
								<button className={`${styles["btn"]} ${styles[hideLoadMore ? 'hide' : '']}`} disabled={isLoading} onClick={showMoreData}>
									<strong style={{ textTransform: 'uppercase' }}>VER MAS NOTAS </strong>
								</button>
							</div>

            </div>
            <div className={`${styles["detail-right"]}`}>
              <PagegrowlerList url='column-lilanews'/>
            </div>
          </div>

          <div className={`${styles['container-bannerHorizontal']}`}>
						<Templates.BannerHorizontalChico bannerId={`horizontal1`} />
					</div>

					<div className={`${styles['detail-full']}`}>
						<div className={`${styles['widget-block']}`}>
              <PagegrowlerList url='column-bottom-lilanews'/>
						</div>
					</div>

					<div className={`${styles['container-bannerHorizontal']}`}>
						<Templates.BannerHorizontalGrande bannerId={`horizontal2`} />
					</div>

        </div>

      </div>
      <div style={{ clear: "both" }}>
        <Footer />
      </div>
    </>
  );
};

export default Titulos;
